mutation UpdateFilterShare($input: FilterShareUpdateInput!) {
    filterShareUpdate(input: $input) {
        filter {
            id
            isShared
            sharedWithEntities {
                id
                name
            }
        }
    }
}
